import type { UnchargedUsageReport } from '@vy/types';
import { caseInsensitiveIncludes, isNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import { UNCHARGED_USAGE_REPORT_COLUMNS } from './UnchargedUsageTableColumns';
import { GridApiPro } from '@mui/x-data-grid-pro';

type UnchargedUsageReportTableProps = {
  rows: UnchargedUsageReport;
  filter?: string;
  apiRef?: React.MutableRefObject<GridApiPro>;
  isLoading?: boolean;
};

export const UnchargedUsageReportTable: React.FC<UnchargedUsageReportTableProps> = ({
  rows,
  isLoading,
  apiRef,
  filter,
}) => {
  const filteredRows = useMemo(() => {
    return rows.filter(
      ({ meterName, customerName }) =>
        isNullOrUndefined(filter) ||
        caseInsensitiveIncludes(meterName, filter) ||
        caseInsensitiveIncludes(customerName, filter),
    );
  }, [rows, filter]);

  return (
    <VyTable
      tableName="uncharged-usage-report"
      itemsCount={filteredRows.length}
      apiRef={apiRef}
      items={filteredRows}
      columns={UNCHARGED_USAGE_REPORT_COLUMNS}
      loadingItems={isLoading}
      getRowId={() => crypto.randomUUID()}
      disableColumnMenu
      paginationMode="client"
      showPagination={false}
      sx={{
        paddingBottom: '80px',
      }}
      hideFooter={false}
    />
  );
};
